import { useState, useEffect } from 'react';

var getVisibility = function getVisibility() {
  if (typeof document === 'undefined') return;
  return document.visibilityState;
};

function useDocumentVisibility() {
  var _useState = useState(getVisibility()),
      documentVisibility = _useState[0],
      setDocumentVisibility = _useState[1];

  useEffect(function () {
    var handleVisibilityChange = function handleVisibilityChange() {
      setDocumentVisibility(getVisibility());
    };

    window.addEventListener('visibilitychange', handleVisibilityChange);
    return function () {
      window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return documentVisibility;
}

export default useDocumentVisibility;